import { Button } from "@/components/ui/button";
import router from "next/router";
import Link from "next/link";
import useTranslation from "next-translate/useTranslation";

export default function DailyNotMember() {
  const { t } = useTranslation("common");

  return (
    <div className="flex flex-col justify-center items-center space-y-4">
      <div className="mb-3 font-medium">
        {t("Please log in to play Daily chess")}
      </div>
      <Link href={"/signIn"}>
        <Button
          size="wide"
          variant="outline"
          onClick={() => router.push("/register")}
        >
          {t("Log in")}
        </Button>
      </Link>
      <Button size="wide" onClick={() => router.push("/register")}>
        {t("Sign up")}
      </Button>
    </div>
  );
}
